import * as Yup from 'yup'
import { t } from 'i18next'
export const register1Schema = () =>
    Yup.object().shape({
        role: Yup.string().required(`Role ${t('is_required')}`),
        full_name: Yup.string()
            .matches(
                /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/,
                'First name cannot contain numbers or special characters',
            )
            .required(`First name ${t('is_required')}`),
        last_name: Yup.string()
            .matches(
                /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/,
                'Last name cannot contain numbers or special characters',
            )
            .required(`Last name ${t('is_required')}`),
        email: Yup.string()
            .email('Invalid email format')
            .required(`Email ${t('is_required')}`),
        phone: Yup.string()
            .matches(/^\+?\d{10,15}$/, 'Phone number must be between 10 to 15 digits')
            .required(`Phone number ${t('is_required')}`),
        address: Yup.string().required(`Address ${t('is_required')}`),
        city: Yup.string().required(`City ${t('is_required')}`),
        state: Yup.string().required(`State ${t('is_required')}`),
        country: Yup.string().required(`Country ${t('is_required')}`),
        zip_code: Yup.string()
            .matches(/^\d{5,6}$/, 'Postcode should be 5 or 6 digits')
            .required(`Postcode ${t('is_required')}`),
        orgNum: Yup.string().when('role', {
            is: (role) => role != 1,
            then: (schema) =>
                schema
                    .matches(
                        /^[\d-]{8,19}$/,
                        'Organisation/VAT number must be between 8 and 16 digits',
                    )

                    .required(`Organisation/VAT number ${t('is_required')}`),
            otherwise: (schema) => schema.notRequired(),
        }),
    })

export const otpSchema = () =>
    Yup.object().shape({
        password: Yup.string()
            .min(8, 'Password contain alteast 8 characters!')
            .required(`Password ${t('is_required')}!`),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password'), undefined], 'Password and confirm password should match!')
            .required(`Confirm password ${t('is_required')}!`),
    })
